import { versionDate } from './versionDate';

export const environment = {
  environmentType: 'dev',
  firebase: {
    storageBucket: 'ce-dev-cloudstg-us-east4',
  },
  production: false,
  isLocal: false,
  isvOidcBaseUrl:
    'https://30188881-maas360.verify.ibm.com/oidc/endpoint/default',
  client_id: 'ecf25aba-6cb0-44bd-8235-c9b6606b69fb',
  client_secret: '8loY2Ejmcu',
  isvBaseUrl: 'https://30188881-maas360.verify.ibm.com',
  theme_id: '2e8c60f3-d466-42b3-9af4-548469f618a2',
  localDomain: 'https://bi-api.dev.dw.beaconconnect.app/home',
  mainapiUrl: 'https://stakeholders-api.dev.beaconconnect.app/v1/core',
  messagingUrl: 'https://messaging-api.dev.beaconconnect.app/v1/messaging',
  dispatchUrl: 'https://dispatch-api.dev.beaconconnect.app/v1/dispatch',
  BIUrl: 'https://bi-api.dev.dw.beaconconnect.app/v1/bi',
  versionDate,
};
